import { useTranslation } from "react-i18next";
import PageHeader from "../../components/common/pageheader/PageHeader";

const TeacherPanelPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader title={t("pages.teacherPanel.title")} />
      {t("pages.teacherPanel.placeholder")}
    </div>
  );
};

export default TeacherPanelPage;
